import { Box, Typography } from '@mui/material';
import { Column, useFilters, useSortBy, useTable } from 'react-table';
import { PositionToCompetitor } from 'shared/types';
import { DateColumn } from './columns/date-column';
import { DeviationFromCompetitorColumn } from './columns/deviation-from-competitor-column';
import { ParameterTable } from './parameter-table';

interface PositionToCompetitorsSectionProps {
    data: PositionToCompetitor[];
}

export function PositionToCompetitorsSection({ data }: PositionToCompetitorsSectionProps) {
    const instance = usePositionToCompetitorTableInstance(data);

    return (
        <Box width={{ xs: '100%', md: '70%', lg: '50%' }}>
            <ParameterTable title='Position To Competitors' instance={instance} />
        </Box>
    );
}

const getRowId = (row: PositionToCompetitor) => row.uniqueId;

export const defaultColumn: Partial<Column<PositionToCompetitor>> = {
    Filter: () => null,
    Cell: ({ value = '' }) => <Typography variant='body2'>{value}</Typography>,
    disableFilters: true,
    width: 100,
    minWidth: 100,
    maxWidth: 100,
    align: 'inherit',
};

const marginTargetColumns: Column<PositionToCompetitor>[] = [
    {
        Header: 'Position To Competitor',
        accessor: 'positionToCompetitor',
        align: 'left',
        title: `Belnick's product value compared to competitor's product`,
    },
    {
        Header: 'Deviation From Competitor',
        accessor: 'deviationFromCompetitor',
        align: 'left',
        Cell: DeviationFromCompetitorColumn,
        title: ' % or dollar for price to deviate from competitor price',
        section: 'positionToCompetitors',
    },
    {
        Header: 'Method',
        accessor: 'method',
        align: 'left',
    },
    {
        Header: 'Last Updated',
        accessor: 'lastUpdated',
        align: 'left',
        Cell: DateColumn,
    },
];

export function usePositionToCompetitorTableInstance(data: PositionToCompetitor[]) {
    return useTable<PositionToCompetitor>(
        {
            columns: marginTargetColumns,
            data,
            defaultColumn,
            getRowId,
            autoResetFilters: false,
            autoResetSortBy: false,
        },
        useFilters,
        useSortBy
    );
}
